import React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import SearchProductCardAdapterNewConsumerApp from '../SearchProductCardAdapter/SearchProductCardAdapterNewConsumerApp';

/**
 * Product grid component for New Consumer App (NextJS)
 * Uses individual product adapters for immediate rendering
 */
const ProductGridNewConsumerApp = connectHits(({ hits }) => {
  if (!hits || hits.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">No products found</div>
    );
  }

  return (
    <ProductCardGridUI
      columnsOnDesktop="3"
      columnsOnMobile="2"
      limitWidth={false}
    >
      {hits.map((hit, index) => (
        <SearchProductCardAdapterNewConsumerApp
          key={hit.objectID}
          hit={hit}
          position={index + 1}
        />
      ))}
    </ProductCardGridUI>
  );
});

export default ProductGridNewConsumerApp;
